"use strict";

import {
    scrollDetector,
    toggleMenu,
    toggleSearchBar,
    languageSwitcher,
    toggleSubMenu,
    hoverSubMenu
} from "./modules/menu.js";

import accordion from "./modules/accordion.js";
import videoControls from "./modules/video-controls.js";
import lightboxGallery from "./modules/lightbox.js";
import formScript from "./modules/form-script.js";
import history from "./modules/history.js";


document.addEventListener("DOMContentLoaded", () => {

    toggleMenu();
    scrollDetector();
    languageSwitcher();
    toggleSubMenu();
    hoverSubMenu();

    accordion();
    videoControls();
    lightboxGallery();
    formScript();
    history();


});

fetch(scriptObj.ajaxurl + '?action=get_new_nonce')
    .then(res => res.json())
    .then(data => {
        if (data.success) {
            scriptObj.nonce = data.data.nonce;
        }
    });